<script>
export default {
    props: [
        'cnpj',
        'cpf',
        'dataNasc'
    ],
    data() {

        return {
            modalReceita: false,
            mostrarCaptcha: false,
            imgCaptcha: "",
            txtCaptcha: "",
            tipoConsulta: "",
            retornoConsulta: [],
        }
    },
    methods: {
        getCaptcha(tipo) {

            this.tipoConsulta = tipo;
            this.retornoConsulta = [];
            this.txtCaptcha = "";

            var vm = this;
            $('.loading').show();
            axios.get('/consulta_receita_federal/get_captcha/' + tipo).then(function (response) {

                vm.imgCaptcha = response.data;

                vm.mostrarCaptcha = true;

                $('.loading').hide();

            }).catch(function (error) {
                $('.loading').hide();
                vm.mostrarCaptcha = false;
                alert("Falha ao Buscar o Captcha");

            });
        },
        consultarCnpjDireto() {
            var vm = this;
            this.tipoConsulta = 'CNPJ';
            this.retornoConsulta = [];

            $('.loading').show();

            axios.post('/consulta_receita_federal/consultar/CNPJ', { cnpj: this.cnpj }).then(function (response) {
                vm.retornoConsulta = response.data;
                $('.loading').hide();
            }).catch(function (error) {
                $('.loading').hide();
                const msg = (error.response && error.response.data && error.response.data.errors) || 'Falha ao consultar CNPJ';
                alert(msg);
            });
        },
        consultarReceita() {
            var vm = this;
            let data = {
                captcha: this.txtCaptcha
            };

            if (this.tipoConsulta == 'CPF') {

                data.cpf = this.cpf;
                data.data_nasc = this.dataNasc;

            } else {
                data.cnpj = this.cnpj;
            }

            $('.loading').show();

            axios.post('/consulta_receita_federal/consultar/' + this.tipoConsulta, data).then(function (response) {
                vm.retornoConsulta = response.data;
                vm.mostrarCaptcha = false;
                $('.loading').hide();
            }).catch(function (error) {
                $('.loading').hide();
                alert("Falha ao conusltar");
                vm.mostrarCaptcha = false;
            });
        },
        showModal() {
            var vm = this;
            this.mostrarCaptcha = false;
            this.retornoConsulta = [];
            this.tipoConsulta = "";
            vm.modalReceita = !vm.modalReceita;
            //$('#modaConsultaReceitaFederal').modal();
        }
    },
    mounted() {

    }
}
</script>

<template>
<div>

    <div class="col-md-12 text-right" style=" margin-top: 10px;">
        <b-button variant="warning" size="sm" @click="showModal">Consultar Receita Federal</b-button>
    </div>

    <!-- ###################################### Modal ################################# -->
    <b-modal v-model="modalReceita" title="Consulta Receita Federal" hide-footer>
        <b-modal-body>
            <div class="row" v-show="!mostrarCaptcha && Object.keys(retornoConsulta).length === 0">
                <div class="col-md-6 text-center">
                    <b-button variant="success" size="sm" @click="getCaptcha('CPF')">Consultar CPF</b-button>
                </div>
                <div class="col-md-6 text-center">
                    <b-button variant="success" size="sm" @click="consultarCnpjDireto">Consultar CNPJ</b-button>
                </div>
            </div>

            <div class="row" v-show='mostrarCaptcha'>
                <div class="col-md-12">
                    <img :src="imgCaptcha" alt="Captcha">

                    <div class="form-group">
                        <label for="">O que você vê na imagem?</label>
                        <input type="text" class="form-control" v-model="txtCaptcha">
                    </div>
                    <div class="text-center">
                        <b-button variant="success" size="sm" @click="consultarReceita">Fazer Consulta</b-button>
                    </div>
                </div>
            </div>

            <div class="row" v-if="Object.keys(retornoConsulta).length > 0">
                <div class="col-md-12">

                    <strong>Status da Consulta: </strong>{{retornoConsulta.status}}
                    <ul v-if="tipoConsulta === 'CPF'">
                        <li>

                            <strong>CPF:</strong>
                            {{retornoConsulta['0']}}
                        </li>
                        <li>

                            <strong>Nome:</strong>
                            {{retornoConsulta['1']}}
                        </li>
                        <li>

                            <strong>Data Nasc:</strong>
                            {{retornoConsulta['2']}}
                        </li>
                        <li>

                            <strong>Situação:</strong>
                            {{retornoConsulta['3']}}
                        </li>
                        <li>

                            <strong>Data Inscrição:</strong>
                            {{retornoConsulta['4']}}
                        </li>

                    </ul>

                    <ul v-if="tipoConsulta === 'CNPJ'">

                        <li>
                            <strong>Razão Social:</strong>
                            {{retornoConsulta.razao_social}}
                        </li>

                        <li>
                            <strong>Nome Fantasia:</strong>
                            {{retornoConsulta.nome_fantasia}}
                        </li>

                        <li>
                            <strong>Data de Abertura:</strong>
                            {{retornoConsulta.data_abertura}}
                        </li>

                        <li>
                            <strong>Situação Cadastral:</strong>
                            {{retornoConsulta.situacao_cadastral}}
                        </li>

                        <li>
                            <strong>CNAE Principal:</strong>
                            {{retornoConsulta.cnae_principal}}
                        </li>

                        <li>
                            <strong>CNAEs Secundários:</strong>
                            <p v-for="atividade in retornoConsulta.cnaes_secundarios" :key="atividade">
                                {{atividade}}
                            </p>
                        </li>

                        <li>
                            <strong>Endereço:</strong>
                            {{retornoConsulta.endereco}} - {{retornoConsulta.municipio}}
                        </li>

                        <li>
                            <strong>Telefone:</strong>
                            {{retornoConsulta.telefone}}
                        </li>
                    </ul>

                    <div class="col-md-12 text-center" v-if="tipoConsulta === 'CPF' && retornoConsulta.status != 'OK'">
                        <b-button variant="danger" size="sm" @click="getCaptcha(tipoConsulta)">Tentar Novamente</b-button>
                    </div>
                </div>
            </div>
            <b-button variant="danger" size="sm" class="float-right mt-5" @click="showModal">Fechar</b-button>
        </b-modal-body>
    </b-modal>
</div>
</template>



// WEBPACK FOOTER //
// resources/assets/js/components/util/ConsultaReceitaFederal.vue